@if (dataSource) {
<mat-grid-list
    cols="1"
    rowHeight="120px"
    gutterSize="16"
>
    <mat-grid-tile>
        <div class="bordered-container no-padding justify-center">
            <div class="wrapper widget-full-width-height-2">
                @for (item of getIndicatorWidgets(); track item) {
                <app-mdr-dashboards-indicator [element]="item"></app-mdr-dashboards-indicator>
                }
            </div>
        </div>
    </mat-grid-tile>
</mat-grid-list>
} @if (dataSource) {
<app-mdr-checks-indicator [element]="dataSource.xdr_alerts"></app-mdr-checks-indicator>
} @if (dataSource) {
<mat-grid-list
    cols="10"
    rowHeight="366px"
    class="m-t-16"
    gutterSize="16"
>
    <mat-grid-tile colspan="6">
        <div class="bordered-container no-padding align-center">
            <div class="h-100">
                <app-mdr-dashboards-banner></app-mdr-dashboards-banner>
            </div>
        </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="4">
        <div class="bordered-container align-center">
            <div class="chart-container">
                <app-mdr-dashboards-group [element]="dataSource.activitySummary"></app-mdr-dashboards-group>
            </div>
        </div>
    </mat-grid-tile>
</mat-grid-list>
} @if (dataSource && !mdrDashboardsService.isLcoCompany(organization)) {
<mat-grid-list
    cols="2"
    rowHeight="262px"
    class="m-t-16"
    gutterSize="16"
>
    <mat-grid-tile>
        <div class="bordered-container align-center">
            <app-mdr-dashboards-table
                [element]="dataSource.recentActivity"
                [mocked]="false"
                [displayedColumns]="dataSource.recentActivity.columns"
            ></app-mdr-dashboards-table>
        </div>
    </mat-grid-tile>
    <mat-grid-tile>
        <div class="bordered-container align-center">
            <app-mdr-dashboards-table
                [element]="dataSource.recentDocuments"
                [mocked]="false"
                [displayedColumns]="dataSource.recentDocuments.columns"
            ></app-mdr-dashboards-table>
        </div>
    </mat-grid-tile>
</mat-grid-list>
} @if (dataSource && !mdrDashboardsService.isLcoCompany(organization)) {
<mat-grid-list
    cols="3"
    rowHeight="398px"
    class="m-t-16 m-b-25"
    gutterSize="16"
>
    <mat-grid-tile>
        <div class="bordered-container align-center">
            <app-mdr-dashboards-table
                [element]="dataSource.topInvestigationCategories"
                [mocked]="false"
                [displayedColumns]="dataSource.topInvestigationCategories.columns"
            ></app-mdr-dashboards-table>
        </div>
    </mat-grid-tile>
    <mat-grid-tile>
        <div class="bordered-container align-center">
            <app-mdr-dashboards-table
                [element]="dataSource.top10ImpactedUsers"
                [mocked]="false"
                [displayedColumns]="dataSource.top10ImpactedUsers.columns"
            ></app-mdr-dashboards-table>
        </div>
    </mat-grid-tile>
    <mat-grid-tile>
        <div class="bordered-container align-center">
            <app-mdr-dashboards-table
                [element]="dataSource.topEndpointsByAlerts"
                [mocked]="false"
                [displayedColumns]="dataSource.topEndpointsByAlerts.columns"
            ></app-mdr-dashboards-table>
        </div>
    </mat-grid-tile>
</mat-grid-list>
} @if (dataSource && mdrDashboardsService.isLcoCompany(organization)) {
<mat-grid-list
    cols="3"
    rowHeight="398px"
    class="m-t-16 m-b-25"
    gutterSize="16"
>
    <mat-grid-tile>
        <div class="bordered-container align-center">
            <app-mdr-dashboards-table
                [element]="dataSource.recentActivity"
                [mocked]="false"
                [displayedColumns]="dataSource.recentActivity.columns"
            ></app-mdr-dashboards-table>
        </div>
    </mat-grid-tile>
    <mat-grid-tile>
        <div class="bordered-container align-center">
            <app-mdr-dashboards-table
                [element]="dataSource.top10ImpactedUsers"
                [mocked]="false"
                [displayedColumns]="dataSource.top10ImpactedUsers.columns"
            ></app-mdr-dashboards-table>
        </div>
    </mat-grid-tile>
    <mat-grid-tile>
        <div class="bordered-container align-center">
            <app-mdr-dashboards-table
                [element]="dataSource.topEndpointsByAlerts"
                [mocked]="false"
                [displayedColumns]="dataSource.topEndpointsByAlerts.columns"
            ></app-mdr-dashboards-table>
        </div>
    </mat-grid-tile>
</mat-grid-list>
}
